import { UsernameInput } from '@/components/Form/UsernameInput/UsernameInput';

import { useTranslate } from '@/hooks/useTranslate';

import { User } from '@/types/user';

import { getAPIFormError } from '@/utils/api';

import { MinorConsentFormData } from '../MinorQuestionConsentSign';

import {
  QuestionBlock,
  QuestionTitle,
  UsernameContainer,
} from '../../QuestionDrawer.styled';

type UsernameQuestionProps = {
  error?: Error | null;
  isPending: boolean;
  minorUser?: User;
};

export const UsernameQuestion = ({
  error,
  isPending,
  minorUser,
}: UsernameQuestionProps) => {
  const { t } = useTranslate();
  const apiError = getAPIFormError<MinorConsentFormData>(error);

  return (
    <QuestionBlock>
      <QuestionTitle variant="captionC1Regular">
        {t('questionDrawer.minorUsername.question')}
      </QuestionTitle>
      <UsernameContainer>
        <UsernameInput
          disabled={isPending}
          apiError={apiError?.username ?? ''}
          hideLabel
          phoneNumber={minorUser?.phoneNumber || ''}
          birthday={minorUser?.birthday}
          placeholder={t('questionDrawer.minorUsername.placeholder')}
          requiredMessage={t('questionDrawer.minorUsername.error.required')}
        />
      </UsernameContainer>
    </QuestionBlock>
  );
};
